import React from 'react';

function NorthMacedonia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124059)">
        <mask
          id="mask0_800_124059"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124059)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F50100"
          />
          <mask
            id="mask1_800_124059"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124059)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.97483e-06 -0.0419616L6.16449e-06 4.04196L15.75 9.99321L3.66214 -0.0419617L5.97483e-06 -0.0419616ZM18 12L21.375 5.41657e-06H14.625L18 12ZM18 12L14.625 24H21.375L18 12ZM6.16449e-06 19.9512L5.97483e-06 24.0352H3.66214L15.75 14L6.16449e-06 19.9512ZM36 4.06634V-0.017578L32.3379 -0.0175781L20.25 10.0176L36 4.06634ZM36 24.0596V19.9756L20.25 14.0244L32.3379 24.0596H36ZM36 9.00001L22.5 12L36 15V9.00001ZM13.5 12L0 9V15L13.5 12Z"
              fill="#FFD018"
            />
            <path
              d="M18 17C20.9236 17 23.5 14.8689 23.5 12C23.5 9.1311 20.9236 7 18 7C15.0764 7 12.5 9.1311 12.5 12C12.5 14.8689 15.0764 17 18 17Z"
              fill="#FFD018"
              stroke="#F50100"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124059">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NorthMacedonia;
